// extracted by mini-css-extract-plugin
export default {"divider":"SignUpDivider_divider__fOrm3","line":"SignUpDivider_line__0lK6n"};